import Button from "../../components/Button/Button";
import TextInput from "./TextInput";
import Image from "../../assets/images/Photo/contact.png";
import Sharky from "../../assets/images/Sharky/Sharky_Waving.png";
import {ReactComponent as HeartDoodle} from "../../assets/images/Doodles/heart.svg";
import {useState} from 'react';

import { useTranslation } from 'react-i18next'

function Contact({className}) {
    const { t } = useTranslation(['common', 'navigation']);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [showingMessage, setShowingMessage] = useState(false);
    const [showingFail, setFail] = useState(false);
    // const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const body = JSON.stringify({
            email: email,
            from: name,
            message: message
        })

        try {
        const response = await fetch('/api/send-email', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: body
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error?.message || 'Error al enviar el correo');
        }

        setEmail('');
        setMessage('');
        setName('');
        setShowingMessage(true);
        } catch (error) {
        setFail(true);
        }
    };

    return(
        <div id='section-contact' className={`relative flex min-h-screen md:h-[800px] bg-slate-500/50 items-start overflow-hidden bg-gradient-to-b from-bluekali-navy-blue to-bluekali-cerulean-blue ${className}`}>
            <div className="flex flex-col h-full justify-between pt-24 md:pt-56 pl-6 w-full">
   
                <div>
                    <h1 className="font-bold text-3xl md:text-5xl md:pb-4">{t('contact.title')}</h1>
                    <h3 className="w-2/3 mb-10 text-sm font-normal">{t('contact.desc')}</h3>
                </div>
                
                <div className="w-2/3 md:w-5/6">
                    <div className="block md:flex md:justify-between md:space-x-4">
                        <div className="md:w-1/2">
                            <p className="pl-4 text-white">{t('contact.name')}</p>
                            <TextInput 
                                type={t('contact.name_input')}
                                height="h-12"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        
                        <div className="md:w-1/2">
                            <p className="pl-4 text-white mt-2 md:mt-0">{t('contact.email')}</p>
                            <TextInput 
                                type={t('contact.email_input')}
                                height="h-12" 
                                isEmail={true}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                    </div>

                    <p className="pl-4 text-white mt-2">{t('contact.message')}</p>
                    <TextInput 
                        type={t('contact.message_input')}
                        height="h-20"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />

                    <Button filled='yei'
                            className="mt-6 w-36 md:w-48 md:rounded-[20px] md:h-12"
                            onClick={handleSubmit}
                            >
                        <h3 className="text-bluekali-navy-blue font-bold">{t('contact.send')}</h3>
                    </Button>
                </div>

                <div className="flex flex-col h-36 w-11/12 justify-end overflow-visible">
                    <div className="flex justify-between items-end">
                        <h3 className="text-sm text-white/60 mb-4">Bluekali © 2026</h3>
                        
                        <div className="flex flex-col items-end">
                            <HeartDoodle className="h-8 text-white translate-x-3 translate-y-8"/>
                            <img src={Sharky} alt="" className="h-40 -scale-x-[1] translate-y-5"/>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>
            <div className="w-full h-full hidden lg:block">
            <img 
                src={Image}
                className="h-full w-full object-cover"
                alt=""
                style={{clipPath: 'polygon(20% 0, 100% 0, 100% 100%, 5% 100%)'}}
            />
            </div>

            { showingMessage &&
                <div
                className="absolute bottom-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50"
                onClick={() => setShowingMessage(false)}
            >
                {/* El div interno AHORA tiene estilos visibles */}
                <div 
                    className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 text-center transform transition-all duration-300 ease-out"
                    onClick={(e) => e.stopPropagation()} // Evita que se cierre al hacer clic en el contenido
                >
                    {/* Icono de éxito */}
                    <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                        </svg>
                    </div>

                    {/* Título */}
                    <h2 className="text-2xl font-bold text-gray-800 mb-3">{t('contact.success_title')}</h2>
                    
                    {/* Mensaje */}
                    <p className="text-gray-600 mb-6">
                        {t('contact.success_desc')}
                    </p>

                    {/* Botón de cerrar */}
                    <button
                        onClick={() => setShowingMessage(false)}
                        className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200"
                    >
                        {t('contact.success_button')}
                    </button>

                    {/* Botón X en la esquina */}
                    <button
                        onClick={() => setShowingMessage(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
            }

            { showingFail &&
                <div
                className="absolute bottom-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50"
                onClick={() => setFail(false)}
            >
                {/* El div interno AHORA tiene estilos visibles */}
                <div 
                    className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 text-center transform transition-all duration-300 ease-out"
                    onClick={(e) => e.stopPropagation()} // Evita que se cierre al hacer clic en el contenido
                >
                    {/* Icono de éxito */}
                    <div className="w-16 h-16 bg-bluekali-complementary-red rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>

                    {/* Título */}
                    <h2 className="text-2xl font-bold text-gray-800 mb-3">{t('contact.fail_title')}</h2>
                    
                    {/* Mensaje */}
                    <div className="mb-6">
                        <p className="text-gray-600">
                            {t('contact.fail_desc')}
                        </p>

                        <a href="mailto:contacto@bluekali.mx" className="text-black hover:text-bluekali-tomato text-sm font-bold">
                        contacto@bluekali.mx
                        </a>
                    </div>
                    

                    {/* Botón de cerrar */}
                    <button
                        onClick={() => setFail(false)}
                        className="bg-bluekali-complementary-red hover:bg-bluekali-tomato text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200"
                    >
                        {t('contact.fail_button')}
                    </button>

                    {/* Botón X en la esquina */}
                    <button
                        onClick={() => setFail(false)}
                        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors duration-200"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
            }

        </div>
    );   
}


export default Contact;